/* Individual product taste surveys: retain each original question and denominator. */
(function () {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('[data-ll-bundle-taste]').forEach(function (root) {
      if (root.dataset.tasteReady) return;
      var select = root.querySelector('[data-ll-bundle-taste-select]');
      var panels = root.querySelectorAll('[data-ll-bundle-taste-panel]');
      if (!select || !panels.length) return;
      root.dataset.tasteReady = 'true';
      function show() {
        panels.forEach(function (panel) {
          panel.hidden = panel.dataset.llBundleTastePanel !== select.value;
          var name = panel.querySelector('.ll-bundle-taste__name');
          if (name) name.hidden = true;
        });
      }
      select.hidden = false;
      select.addEventListener('change', show);
      show();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
